import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';
import ResponsiveHeading from 'app/shared/StyledComponents/ResponsiveText';

export const SearchHeroModule = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mediaMixin(
    'md',
    css`
      height: 450px;
    `,
  )};
`;

export const SearchHeroModuleContent = styled.div`
  margin-left: 24px;
  margin-right: 24px;

  ${mediaMixin(
    'md',
    css`
      margin: auto;
      padding: 0 24px;
      width: 100%;
      max-width: 750px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `,
  )};
`;

export const HeroHeading = styled(ResponsiveHeading as any)`
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
`;
